export default __webpack_public_path__ + "static/media/ClientIcon.a758944f.svg";